import React from 'react';
import { Mail, ArrowRight } from 'lucide-react';

const ContactUs = () => {
    return (
        <div className="ct-page">
            <main>
                <section className="ct-hero">
                    <div className="ix-container ct-inner">

                        <div className="ct-text">
                            <div className="ct-eyebrow mono">Contact</div>
                            <h1 className="ct-title">
                                Get in <em>touch.</em>
                            </h1>
                            <p className="ct-sub">
                                Have a question, a problem, or just something to say? We read every message.
                            </p>
                        </div>

                        <div className="ct-card">
                            <div className="ct-card-icon">
                                <Mail size={22} />
                            </div>
                            <div className="ct-card-label mono">Email us directly</div>
                            <a
                                href="mailto:interimgig@gmail.com"
                                className="ct-card-email"
                            >
                                interimgig@gmail.com
                            </a>
                            <p className="ct-card-note mono">We usually reply within 24 hours.</p>
                            <a
                                href="mailto:interimgig@gmail.com"
                                className="ix-btn ix-btn-primary ct-card-btn"
                                style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}
                            >
                                Send an email <ArrowRight size={15} />
                            </a>
                        </div>

                    </div>
                </section>
            </main>
        </div>
    );
};

export default ContactUs;
